import { useCallback, useEffect, useRef } from 'react';
import { IAdvertFuseProps } from '../types.js';
import { AdLogic, AdQuery } from './fuse-log.js';

export type AdLoggerReturn = (type: AdQuery) => void;

export const adLoggerInit =
  ({
    origin,
    fuseTag,
    adUnitPath,
    fuseDataAttr,
  }: Pick<IAdvertFuseProps, 'origin' | 'fuseTag' | 'adUnitPath'> & {
    fuseDataAttr: Record<string, string>;
  }): AdLoggerReturn =>
  (type: AdQuery) => {
    AdLogic({
      type,
      origin,
      fuseDataAttr,
      fuseTag,
      adUnitPath,
    });
  };

export const FuseLoggerHook = ({
  fuseTag,
  adUnitPath,
  origin,
  fuseDataAttr,
}: Pick<IAdvertFuseProps, 'fuseTag' | 'adUnitPath' | 'origin'> & {
  fuseDataAttr: Record<string, string>;
}) => {
  const adLoggerRef = useRef<AdLoggerReturn>();

  /** Update AdLogger Ref with props change */
  useEffect(() => {
    adLoggerRef.current = adLoggerInit({ fuseTag, adUnitPath, origin, fuseDataAttr });
  }, [fuseTag, adUnitPath, origin, fuseDataAttr]);

  const logger = useCallback((a: AdQuery) => {
    adLoggerRef.current?.(a);
  }, []);

  return { logger };
};
